import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Welcome() {
  return <section id="about" className="py-24 bg-white relative overflow-hidden" data-id="element-162">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gray-50 skew-x-12 translate-x-20 z-0" data-id="element-163"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-164">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-165">
          <div className="order-2 md:order-1" data-id="element-166">
            <div className="inline-block px-3 py-1 bg-[#f59e0b]/10 text-[#f59e0b] rounded-full text-sm font-bold tracking-wider mb-6" data-id="element-167">
              WHO WE ARE
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#0a1628] mb-6 leading-tight" data-id="element-168">
              Welcome To <br data-id="element-169" />
              <span className="text-[#f59e0b]" data-id="element-170">Nawat Tech</span>
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed text-lg" data-id="element-171">
              At Nawat Tech, we believe in the power of technology to transform
              businesses and lives. Founded in the heart of the UAE, our mission
              is to bring cutting-edge solutions to the region, fostering
              innovation and security in an increasingly digital world.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-172">
              Our team consists of industry experts, creative thinkers, and
              technical wizards dedicated to delivering excellence. Whether it's
              securing your digital assets or leveraging AI for business growth,
              we are here to guide you every step of the way.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-173">
              {['Innovative AI Solutions', 'Advanced Cybersecurity', 'Strategic Tech Consulting', 'UAE-based Expertise'].map(item => <div key={item} className="flex items-center gap-3 p-3 rounded-lg bg-gray-50 border border-gray-100 hover:border-[#f59e0b]/30 hover:bg-[#f59e0b]/5 transition-colors" data-id="element-174">
                  <CheckCircle2 className="text-[#f59e0b] w-5 h-5 flex-shrink-0" data-id="element-175" />
                  <span className="text-[#0a1628] font-medium" data-id="element-176">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="relative order-1 md:order-2 group" data-id="element-177">
            <div className="absolute -inset-4 bg-gradient-to-tr from-[#f59e0b] to-blue-600 rounded-2xl opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-500" data-id="element-178"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-179">
              <img src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=2070&auto=format&fit=crop" alt="Dubai Skyline Futuristic" className="w-full h-auto object-cover aspect-[4/3]" data-id="element-180" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a1628]/80 via-transparent to-transparent" data-id="element-181"></div>

              <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-182">
                <div className="bg-white/10 backdrop-blur-md border border-white/20 p-6 rounded-xl" data-id="element-183">
                  <p className="text-white font-bold text-xl mb-2" data-id="element-184">
                    Reshaping the UAE Tech Landscape
                  </p>
                  <p className="text-gray-200 text-sm" data-id="element-185">
                    Pioneering digital transformation across the Emirates
                  </p>
                </div>
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -top-6 -right-6 bg-white p-4 rounded-xl shadow-xl animate-float hidden md:block" data-id="element-186">
              <div className="flex items-center gap-3" data-id="element-187">
                <div className="w-10 h-10 bg-[#f59e0b]/10 rounded-full flex items-center justify-center text-[#f59e0b] font-bold" data-id="element-188">
                  #1
                </div>
                <div data-id="element-189">
                  <p className="text-xs text-gray-500 uppercase font-bold" data-id="element-190">
                    Trusted Partner
                  </p>
                  <p className="text-[#0a1628] font-bold" data-id="element-191">In Innovation</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}